module.exports = __webpack_public_path__ + "img/egfrnet_white.5ce6818e.svg";